import { render, staticRenderFns } from "./TeacherCreate.vue?vue&type=template&id=ff2cea12&scoped=true&"
import script from "./TeacherCreate.vue?vue&type=script&lang=ts&"
export * from "./TeacherCreate.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherCreate.vue?vue&type=style&index=0&id=ff2cea12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2cea12",
  null
  
)

export default component.exports